export const comparePath = (path1: string, path2: string): boolean => {
    const part1 = path1.split('/');
    const part2 = path2.split('/');
    if (part1.length !== part2.length) {
        return false;
    }
    return part1.every((p1, index) => {
        const p2 = part2[index];
        if (p1.indexOf(':') >= 0 || p2.indexOf(':') >= 0) {
            return true;
        }
        return p1 === p2;
    });
};
